var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page',[_c('template',{slot:"content"},[_c('help-content',{attrs:{"title":'WeBandの睡眠や歩数がアプリに反映されない'}},[_c('template',{slot:"content"},[_c('div',{staticClass:"text"},[_c('b',[_vm._v("ペアリングが切れた場合")]),_vm._v("の回答にしたがって操作してください。"),_c('br')])])],2)],1)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-048b9e30","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Help19.vue
// module id = gxwQ
// module chunks = 0